import { IndustryTemplate } from '@/components';
import { plumbingContent } from '@/data/industries/plumbing';

export function PlumbingPage() {
  return <IndustryTemplate content={plumbingContent} />;
}
